let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5BErq")).then(() => parcelRequire('7azBh'));